const FormHelperText = () => {
  return {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginTop: '2px',
          marginInline: '5px',
        },
      },
    },
  };
};
export default FormHelperText;
